var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
import { __decorate, __metadata } from "tslib";
import infraService from "@/core/services/infraService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { MenuActions } from "@/store/enums/InfraEnums";
import { Module, Action, VuexModule, Mutation } from "vuex-module-decorators";
import store from "@/store/";
let MenuModule = class MenuModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.storage = window.localStorage;
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
        this.menus = [];
    }
    get getMenus() {
        let menuData = this.storage.getItem('63880342571d4d3e6c5b393f428cd3de');
        if (this.menus.length == 0 && JwtService.getToken() && menuData) {
            let menuLocal = atob(menuData);
            if (menuLocal)
                store.dispatch(MenuActions.SET_MENU_ACTION, JSON.parse(menuLocal));
        }
        return this.menus;
    }
    [_a = Mutations.SET_MENU](data) {
        if (this.storage.getItem('63880342571d4d3e6c5b393f428cd3de'))
            this.storage.removeItem('63880342571d4d3e6c5b393f428cd3de');
        let menuData = btoa(JSON.stringify(data));
        this.storage.setItem('63880342571d4d3e6c5b393f428cd3de', menuData);
        this.menus = data;
    }
    [_b = MenuActions.SET_MENU_ACTION](menu) {
        this.context.commit(Mutations.SET_MENU, menu);
    }
    [_c = MenuActions.POST_MENU](data) {
        return new Promise(resolve => {
            infraService.post("Menu/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = MenuActions.PUT_MENU](data) {
        return new Promise(resolve => {
            infraService.put("Menu/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = MenuActions.DELETE_MENU](data) {
        return new Promise(resolve => {
            infraService.delete("Menu/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = MenuActions.DELETE_RANGE_MENU](data) {
        return new Promise(resolve => {
            infraService.delete("Menu/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = MenuActions.FILTER_MENU](data) {
        return new Promise(resolve => {
            infraService.post("Menu/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = MenuActions.GET_MENU]() {
        return new Promise(resolve => {
            infraService.get("Menu/Get")
                .then(({ data }) => {
                this.context.commit(Mutations.SET_MENU, data.values);
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = MenuActions.GET_ALL_MENU]() {
        return new Promise(resolve => {
            infraService.get("Menu/GetAll")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = MenuActions.GET_BY_ID_MENU](data) {
        return new Promise(resolve => {
            infraService.get("Menu/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_l = MenuActions.GET_BY_STRING_MENU](data) {
        return new Promise(resolve => {
            infraService.get("Menu/GetByString", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_m = MenuActions.GET_PAGED_BY_STRING_MENU](data) {
        return new Promise(resolve => {
            infraService.get("Menu/GetPagedByString", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _k, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _l, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], MenuModule.prototype, _m, null);
MenuModule = __decorate([
    Module
], MenuModule);
export default MenuModule;
//# sourceMappingURL=MenuModule.js.map